<!--
 * 提示图标与tooltip组合
-->
<template>
  <a-tooltip
    v-bind="$attrs"
    v-on="$listeners"
    placement="top"
    :overlayStyle="{ maxWidth: width }"
  >
    <template slot="title">
      <div v-if="title" class="question-tooltip-content">{{ title }}</div>
      <slot v-else name="title" />
    </template>
    <a-icon type="question-circle" class="question-tooltip-icon cursor-pointer" />
  </a-tooltip>
</template>

<script>
export default {
  name: "QuestionTooltip",
  props: {
    /**
     * 内容
     */
    title: {},
    /**
     * 弹窗宽度
     */
    width: {
      type: String,
      default: '250px',
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
.ant-form-item label > .question-tooltip-icon {
  vertical-align: text-top;
  font-size: initial;
  margin: 0 2px;
}

.question-tooltip-content {
  white-space: break-spaces;
}
</style>
